// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  announcements: [],
  isCreatedAnnouncement: false,
}

export const mutations = {
  SET_ANNOUNCEMENTS(state, announcements) {
    state.announcements = announcements
  },
  SET_IS_CREATED_ANNOUNCEMENT(state, value) {
    state.isCreatedAnnouncement = value
  },
  ADD_ANNOUNCEMENT(state, announcement) {
    state.announcements.push(announcement)
  },
  EDIT_ANNOUNCEMENT(state, announcement) {
    const index = state.announcements.findIndex(
      (item) => item.announcement_uuid === announcement.announcement_uuid
    )
    if (index !== -1) state.announcements.splice(index, 1, announcement)
  },
  DELETE_ANNOUNCEMENT(state, announcement_uuid) {
    const index = state.announcements.findIndex(
      (item) => item.announcement_uuid === announcement_uuid
    )
    if (index !== -1) state.announcements.splice(index, 1)
  },
}

export const actions = {
  fetchAnnouncements({ commit }, payload) {
    return ApiService.fetchAnnouncements(payload)
      .then((res) => {
        const announcements = res.data.data
        commit('SET_ANNOUNCEMENTS', announcements)
      })
      .catch((error) => {
        throw error
      })
  },
  addAnnouncement({ commit }, payload) {
    return ApiService.addAnnouncement(payload)
      .then((res) => {
        const announcement = res.data
        commit('ADD_ANNOUNCEMENT', announcement)
        return announcement
      })
      .catch((error) => {
        throw error
      })
  },
  editAnnouncement({ commit }, payload) {
    return ApiService.editAnnouncement(payload)
      .then((res) => {
        const announcement = res.data
        commit('EDIT_ANNOUNCEMENT', announcement)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteAnnouncement({ commit }, payload) {
    return ApiService.deleteAnnouncement(payload)
      .then(() => {
        commit('DELETE_ANNOUNCEMENT', payload.announcement_uuid)
      })
      .catch((error) => {
        throw error
      })
  },
  sendAnnouncement(_, payload) {
    return ApiService.sendAnnouncement(payload).catch((error) => {
      throw error
    })
  },
}

export const getters = {}
